import { gql } from "@apollo/client";

export const UpdateIoTConnection = gql`
    mutation UpdateIoTConnection ($assetLocationId: ID!, $input: IoTConnectionUpdateAttributesInput!) {
        updateIoTConnection (assetLocationId: $assetLocationId, input: $input) {
            id
        }
    }
`;
